// extracted by mini-css-extract-plugin
var _1 = "bpl__action-table-row__jnVID";
var _2 = "bpl__action-table-row__content__Zl2a3";
export { _1 as "action-table-row", _2 as "action-table-row__content" }
